var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80204 0.477085C2.97525 0.0922738 3.58408 0.0922738 3.7573 0.477085L4.38842 1.88257L6.07898 1.98528C6.54203 2.01326 6.72982 2.53107 6.37396 2.79707L5.07399 3.76829L5.4873 5.23701C5.60049 5.63946 5.10743 5.95911 4.71469 5.73911L3.27967 4.93346L1.84464 5.73873C1.4519 5.95911 0.958841 5.63907 1.07203 5.23701L1.48535 3.76829L0.185376 2.79707C-0.170487 2.53107 0.0177343 2.01326 0.480356 1.98528L2.17092 1.88257L2.80204 0.477085Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaron);
export default __webpack_public_path__ + "static/media/star=on.7d1989f685f82a565697e042791d68e1.svg";
export { ForwardRef as ReactComponent };